// src/services/endpoints/administrator.ts
export const administratorEndpoints = {
  // Collection
  listAdmins: '/private/v1/admins',
  createAdmin: '/private/v1/admins',

  // Single resource
  getAdminById: (id: string) => `/private/v1/admins/${id}`,
  updateAdminById: (id: string) => `/private/v1/admins/${id}`,
  deleteAdminById: (id: string) => `/private/v1/admins/${id}`,

  // Actions on a single admin
  updateAdminStatusById: (id: string) => `/private/v1/admins/${id}/update-status`,
  forceAdminLogoutById: (id: string) => `/private/v1/admins/${id}/force-logout`,
  resetAdminCredentialsById: (id: string) => `/private/v1/admins/${id}/force-login-credentials-reset`,
} as const;
